// extracted by mini-css-extract-plugin
export default {"wrapper":"LocalCellIdsList_wrapper__favOW","cellsWrapper":"LocalCellIdsList_cellsWrapper__PqFt9"};